import { render, staticRenderFns } from "./DetailFeedback.vue?vue&type=template&id=67880bbd&scoped=true&"
import script from "./DetailFeedback.vue?vue&type=script&lang=js&"
export * from "./DetailFeedback.vue?vue&type=script&lang=js&"
import style0 from "./DetailFeedback.vue?vue&type=style&index=0&id=67880bbd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67880bbd",
  null
  
)

export default component.exports